import React, { Component } from 'react';
import {Button} from '@betareader/design-system';
// i18n
import { withTranslation } from 'react-i18next';
// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import { listOpportunities, loadMoreOpportunities, listRecommendations } from '../../modules/betaOpportunities';
import BetaOpportunityItem from './betaOpportunityItem';

import { getFreshIdToken } from '../../utils/authUtil';
import Ux from '../../utils/uxAnalyticsUtil';

export class DiscoverBookList extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const { history } = this.props;
    Ux.trackPageView(history.location.pathname);
    this.listOpportunities();
  }

  componentDidUpdate(prevProps) {
    const { location, history } = this.props;
    if (location !== prevProps.location
      || this.props.userProfile?._id !== prevProps.userProfile?._id
      || this.props.userProfile?.showAiGeneratedManuscripts !== prevProps.userProfile?.showAiGeneratedManuscripts) {
      Ux.trackPageView(history.location.pathname);
      // check if we are currently searching and toggle content carusels
      // fetch new opportunities
      this.listOpportunities();
    }
  }

  listOpportunities = async () => {
    const { match } = this.props;
    const idToken = await getFreshIdToken();
    const genre = match.params.genre;
    // if we don't have any options fallback to default filter
   const options = {
      dimension: 'genre',
      genres: genre
    };
    this.props.listOpportunities(idToken, options);
  }

  loadMore = async () => {
    const {booksByDimension, loadingOpportunities} = this.props;
    if (loadingOpportunities || !booksByDimension?.[0]) return;
    const idToken = await getFreshIdToken();
    const { match } = this.props;
    const genre = match.params.genre;

    this.props.loadMoreOpportunities(idToken, {
      dimension: 'genre',
      genres: genre,
      skip: booksByDimension[0].books.length
    });
  }

  render() {
    const {
      t, loadingOpportunities, booksByDimension
    } = this.props;
    return (
      <main style={{maxWidth: 900, margin: '0 auto', padding: 'var(--br-space-4)'}}>
        {
          booksByDimension && booksByDimension.length > 0
          && <h1>{booksByDimension[0].genre}</h1>
        }
        <div>
          { loadingOpportunities
            && <p role='status'>{t('Loading')}</p>
          }
          {
            booksByDimension && booksByDimension.length > 0 && booksByDimension[0].books.length > 0
            && booksByDimension[0].books.map(book => <BetaOpportunityItem key={book._id} book={book} />)
          }
          {
            booksByDimension && booksByDimension.length > 0 && booksByDimension[0].books.length === 0
            && <p>{t('NothingHere')}</p>
          }
        </div>
        {
          booksByDimension && booksByDimension.length > 0 && booksByDimension[0].books.length > 0
          && (
            <Button variant='secondary' onClick={this.loadMore}
              disabled={loadingOpportunities} aria-busy={loadingOpportunities}>
              {t('LoadMore')}
            </Button>
          )
        }
      </main>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile,
  idToken: state.user.idToken,
  books: state.betaOpportunities.books,
  booksByDimension: state.betaOpportunities.booksByDimension,
  recommendations: state.betaOpportunities.recommendations,
  loadingRecommendations: state.betaOpportunities.loadingRecommendations,
  loadingOpportunities: state.betaOpportunities.loadingOpportunities,
  searchTerm: state.betaOpportunities.searchTerm
});

const mapDispatchToProps = dispatch => bindActionCreators({
  listOpportunities,
  loadMoreOpportunities,
  listRecommendations,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscoverBookList)));
